import React from "react";

/** Shared ambient mesh / grid / orbs for green auth surfaces. */
const AuthAmbientLayers: React.FC = () => (
  <>
    <div className="am-bg am-bg--mesh" />
    <div className="am-bg am-bg--grid" />
    <div className="am-orb am-orb--one" />
    <div className="am-orb am-orb--two" />
  </>
);

export default AuthAmbientLayers;
